import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `TipoAlimentacion`, method: 'GET', body: null, token: token})
}
